import { create } from "zustand";

interface AppointmentLocationPromptStore {
  /**
   * Asks the app-level prompt to open, for flows that leave the screen they
   * started on before the user could answer (e.g. the "AI Note" quick action,
   * which closes the sidebar and moves to the patient). `requestId` is bumped
   * per request so asking again re-mounts the prompt.
   */
  request: {
    locationId: string;
    appointmentId?: string;
    requestId: number;
  } | null;
  requestLocationPrompt: (locationId: string, appointmentId?: string) => void;
  /**
   * Appointments the user chose to stay away from this session, so starting a
   * note in one screen and finishing it in the next asks only once.
   */
  declinedAppointmentIds: Record<string, true>;
  declineAppointment: (appointmentId: string) => void;
}

export const useAppointmentLocationPromptStore =
  create<AppointmentLocationPromptStore>((set, get) => ({
    request: null,
    requestLocationPrompt: (locationId, appointmentId) =>
      set({
        request: {
          locationId,
          appointmentId,
          requestId: (get().request?.requestId ?? 0) + 1,
        },
      }),
    declinedAppointmentIds: {},
    declineAppointment: (appointmentId) =>
      set((state) => ({
        declinedAppointmentIds: {
          ...state.declinedAppointmentIds,
          [appointmentId]: true,
        },
      })),
  }));
